import { render, staticRenderFns } from "./ImageCapture.vue?vue&type=template&id=5c64fa89&scoped=true"
import script from "./ImageCapture.vue?vue&type=script&lang=js"
export * from "./ImageCapture.vue?vue&type=script&lang=js"
import style0 from "./ImageCapture.vue?vue&type=style&index=0&id=5c64fa89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64fa89",
  null
  
)

export default component.exports